module.exports = __webpack_public_path__ + "img/sft.7b462b77.svg";